module.exports = "https://cdn.realtymogul.com/static/media/img_panel_REITs.507e100c.jpg";